<template>
  <div class="details">
    <Status :status="status" />

    <div class="details__content" :style="`height: ${contentHeight}px; overflow: auto;`">
      <Actions @handleDetailsToggle="handleDetailsToggle" />
      <Locations :ride="ride" />
      <DriverInfo :driver="driver" />
      <EmployeeInfo :data="employeeInfo" />
      <ReceiverInfo v-if="receiverInfo" :data="receiverInfo" />
    </div>

    <Footer
      v-if="footerVisible"
      :ride="ride"
      @cancelRide="cancelRide"
    />
  </div>
</template>

<script>
import { calcContentHeight } from 'utils/functions'
import Status from 'components/newWebCall/drawer/rideList/rideDetails/Status'
import Actions from 'components/newWebCall/drawer/rideList/rideDetails/Actions'
import Locations from 'components/newWebCall/drawer/rideList/rideDetails/Locations'
import DriverInfo from 'components/newWebCall/drawer/rideList/rideDetails/DriverInfo'
import EmployeeInfo from 'components/newWebCall/drawer/rideList/rideDetails/EmployeeInfo'
import ReceiverInfo from 'components/newWebCall/drawer/rideList/rideDetails/ReceiverInfo'
import Footer from 'components/newWebCall/drawer/rideList/rideDetails/Footer'

export default {
  name: 'RideDetails',
  props: {
    ride: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Status,
    Actions,
    Locations,
    DriverInfo,
    EmployeeInfo,
    Footer,
    ReceiverInfo
  },
  data () {
    return {
      contentHeight: null
    }
  },
  computed: {
    status () {
      return this.ride && this.ride.status ? this.ride.status : null
    },

    footerVisible () {
      return this.status === 'WAITING_DRIVERS_ANSWERS' ||
        this.status === 'CAR_ON_THE_WAY' ||
        this.status === 'CAR_ARRIVED' ||
        this.status === 'WAITING_FOR_PASSENGER'
    },

    driver () {
      return this.ride && this.ride.running && this.ride.running.driver && this.ride.running.driver
        ? this.ride.running.driver
        : {}
    },

    employeeName () {
      return this.ride && this.ride.employeeName ? this.ride.employeeName : null
    },

    costCenterName () {
      return this.ride && this.ride.costCenterName ? this.ride.costCenterName : null
    },

    projectName () {
      return this.ride && this.ride.projectName ? this.ride.projectName : null
    },

    employeeInfo () {
      return {
        employeeName: this.employeeName,
        costCenterName: this.costCenterName,
        projectName: this.projectName
      }
    },

    receiverInfo () {
      if (!this.ride.receiver) return null
      const { name, phone, verifyCode } = this.ride.receiver || {}
      if (!name && !phone && !verifyCode) return null
      return {
        receiverName: name || '',
        receiverPhone: phone || '',
        receiverCode: verifyCode || ''
      }
    }
  },
  methods: {
    calcContentHeight () {
      this.contentHeight = calcContentHeight()
    },

    handleDetailsToggle () {
      this.$emit('handleDetailsToggle')
    },

    cancelRide () {
      this.$emit('rideEvent', {
        event: 'cancel',
        ride: this.ride
      })
    }
  },
  watch: {
    ride (val) {
      !val && this.handleDetailsToggle()
    },

    footerVisible () {
      setTimeout(() => this.calcContentHeight(), 200)
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.details__content {
  padding: 12px 16px 16px;
}
</style>
